// extracted by mini-css-extract-plugin
export default {"hsMobileFooter":"MobileFooterAdvisor_hsMobileFooter__liiDV","moreIcon":"MobileFooterAdvisor_moreIcon__eLgv8"};